import { Children, type ReactNode } from "react";
import { cn } from "@carry/ui";

export function BottomBar({ children }: { children: ReactNode }) {
  const actions = Children.toArray(children);
  const actionCount = actions.length;

  return (
    <div
      className={cn(
        "safe-bottom fixed bottom-0 left-0 right-0 mx-auto grid max-w-[480px] gap-2 border-t border-[var(--rule-soft)] bg-[var(--bg-raised)] px-3.5 pt-2.5 [&>*]:w-full",
        actionCount === 1 ? "grid-cols-1" : "grid-cols-2",
        actionCount === 3 && "[&>*:last-child]:col-span-2",
      )}
    >
      {actions}
    </div>
  );
}
